import styled, { css } from 'styled-components'

import { IconButtonStyled } from './IconButtonStyled'

export const TransparentIconButtonStyled = styled((props) => (
  <IconButtonStyled role='button' {...props} />
))`
  ${(props) => {
    const button = props.theme.colors.button.transparentIcon

    return css`
      color: ${props.iconColor || button.content.default};
      background-color: transparent;
      border-color: transparent;
      box-shadow: none;

      &:visited {
        color: ${props.iconColor || button.content.default};
      }

      &:hover {
        color: ${props.iconColor || button.content.default};
        background-color: ${button.content.hover};
        border-color: transparent;
      }

      &:active {
        color: ${props.iconColor || button.content.default};
        background-color: transparent;
        border-color: transparent;
      }

      &[disabled] {
        background-color: transparent;
        border-color: transparent;

        &:hover,
        &:active {
          background-color: transparent;
          border-color: transparent;
        }
      }
    `
  }}
`
